import {
  Box,
  Checkbox,
  FormControlLabel,
  Tooltip,
  Typography,
} from '@mui/material';
import { ComponentType } from 'react';
import { ContextDataItem } from '../../../types/widget';
import { TOOLTIP_Z_INDEX } from '../../Recorder/styles/recorderStyles';
import { useContextSelection } from '../hooks/useContextSelection';
import { contextPanelStyles as styles } from '../styles/ContextPanelStyles';

interface ContextItemProps {
  item: ContextDataItem;
  level?: number;
  requiredContextKeys?: string[];
}

export const ContextItem: ComponentType<ContextItemProps> = ({
  item,
  level = 0,
  requiredContextKeys = [],
}) => {
  const { isSelected, toggleSelection } = useContextSelection();

  const isRequiredItem = requiredContextKeys.includes(String(item.key));
  const hasRequiredChildren =
    item.children?.some((child) =>
      requiredContextKeys.includes(String(child.key))
    ) ?? false;
  const hasNullValue = item.value === null;
  const disabled = isRequiredItem || hasRequiredChildren || hasNullValue;
  const checked = disabled ? (hasNullValue ? false : true) : isSelected(item.key);

  const handleChange = () => {
    if (!item.hidden && !disabled) {
      toggleSelection(item.key);
    }
  };

  return (
    <Box sx={styles.contextItemContainer}>
      <FormControlLabel
        control={
          <Tooltip
            title={disabled ? (hasNullValue ? 'No data available' : 'Required for selected template') : ''}
            arrow
            placement="left"
            slotProps={{
              popper: {
                sx: {
                  zIndex: TOOLTIP_Z_INDEX,
                },
              },
            }}
          >
            <span>
              <Checkbox
                checked={checked}
                onChange={handleChange}
                disabled={disabled}
                size='medium'
                sx={styles.checkbox}
              />
            </span>
          </Tooltip>
        }
        label={
          <Typography
            sx={
              disabled
                ? styles.contextItemTextDisabled
                : styles.contextItemText
            }
          >
            {item.label}
          </Typography>
        }
        sx={styles.contextItemLabel}
      />

      {item.children && (
        <Box sx={styles.contextItemChildrenContainer}>
          {item.children.map((child) => (
            <ContextItem
              key={child.key}
              item={child}
              level={level + 1}
              requiredContextKeys={requiredContextKeys}
            />
          ))}
        </Box>
      )}
    </Box>
  );
};
